export const isLocalhost = 
   ["localhost", "127.0.0.1"].indexOf(window.location.hostname) !== -1;
